

//algolia full text search
import algoliaSearch from 'algoliasearch';

var searchClient = algoliaSearch('OPBAWRWYO4', 'e15d7b9eb8bd33d2a2170647e4393531');
var productIndex = searchClient.initIndex('Products');

/*
export const applySettings = () => {
    productIndex.setSettings({
        searchableAttributes: ['name', 'productID', 'productIDNumber'],
        queryType: 'prefixLast'
      });
}
*/
export const searchProducts = (query, category ) => {

    return new Promise(function(resolve, reject) {
        
        var filter = "isVisible:true ";
        
        if(category) 
            filter = filter + "AND categoryID:" + category 
        
           // productIndex.clearCache();
        productIndex.search({query: query, filters: filter, hitsPerPage: 60}).then(results => {
            
            var objs = [];
            
            for(var i = 0; i < results.hits.length; i++) {
                var obj = results.hits[i];
                objs.push(obj);
            }

            resolve(objs);
        });
    });
}

export const getProductsIDs = (query, category, referenceData) => {

    return new Promise(function(resolve, reject) {
        
        var filter = "categoryID:" + category 
        
    /*      
        filter = filter + " AND "        
        filter = filter + "isVisible:true"
    */

        productIndex.search({query: query, filters: filter, attributesToRetrieve: [
            "id",
            "content"
          ], hitsPerPage: 500}).then(results => {
            
            var objs = [];
            
            for(var i = 0; i < results.hits.length; i++) {
                var obj = results.hits[i];
                obj.referenceData = referenceData;
                objs.push(obj);
            }

            resolve(objs);
        });
    });
}




// WEBPACK FOOTER //
// ./src/assets/algolia/algolia.js